<section class="w-full h-full p-3 roomLimitWrapper">
  <div class="w-full flex justify-between items-center flex-col">
    <div class="w-full flex justify-between items-center p-3">
      <div>
        <span class="text-lg font-semi-bold">تغییر تاریخ</span>
      </div>
      <button mat-ripple mat-flat-button class="flex text-center justify-center items-center" (click)="closeModal()">
        <i
          class="ico-Close cursor-pointer block !text-2xl text-center !font-semi-bold"
        ></i>
      </button>
    </div>
    <div class="w-full flex justify-start items-start p-5">
      <div class="w-full flex-1 items-start justify-start">
        <i class="ico-DangerTriangle cursor-pointer block ml-3 text-xl"></i>
      </div>
      <div class="w-full flex-2 flex-col justify-center items-start space-y-2">
        <span
          class="block text-sm font-semibold"
          *ngIf="isInLimitRange && !isHourly"
        >
          امکان رزرو
          <span class="!font-extrabold text-md">کمتر از {{ limitTo }} شب</span>
          برای این اتاق امکان پذیر نیست. لطفا تاریخ اقامت خود را تغییر دهید.
        </span>
        <span
          class="block text-md font-semibold"
          *ngIf="
            roomInfo.roomAvailableDate.checkInLimit
          "
          >انتخاب تاریخ
          <span class="!font-extrabold">{{
            startDate().split('/')[2] + ' ' + month()
          }}</span>
          به عنوان روز ورود امکان پذیر نیست. لطفا روز ورود خود را تغییر
          دهید.</span
        >
        <span
          class="block text-md font-semibold"
          *ngIf="
            roomInfo.roomAvailableDate.checkOutLimit
          "
          >انتخاب تاریخ
          <span class="!font-extrabold">{{
            endDate().split('/')[2] + ' ' + month()
          }}</span>
          به عنوان روز خروج امکان پذیر نیست. لطفا روز خروج خود را تغییر
          دهید.</span
        >
        <!-- <span
          class="block text-md font-semibold"
          *ngIf="
            roomInfo.roomAvailableDate.checkOutLimit &&
            roomInfo.roomAvailableDate.checkInLimit
          "
        >
          در این تاریخ امکان ورود و خروج وجود ندارد
        </span> -->
        <span
          class="block text-md font-semibold self-end md:w-full"
          *ngIf="isHourly && nightsToStand > 1"
        >
          این اتاق تنها امکان رزرو ساعتی دارد.
          <br>
           رزرو <span class="!font-extrabold">بیشتر از 1 شب</span> در این اتاق امکان
          پذیر نیست. لطفا تاریخ اقامت خود را تغییر دهید.
        </span>
      </div>
    </div>
    <div
      class="iho-datepicker w-full h-full flex justify-center md:static fixed bottom-5 right-0 items-end p-5 lg:p-0 lg:pt-5"
    >
      <button
        ihoDatepicker
        [allowToShow]="!isMobile"
        [isMobile]="isMobile"
        (click)="changedate()"
        mat-ripple
        mat-flat-button
        color="primary"
        class="w-full !h-11 !text-base font-semi-bold p-3"
      >
        تغییر تاریخ
      </button>
    </div>
  </div>
</section>
